<template>
  <div>
    <div
      class="modal fade"
      id="modalInventarioXposicionXproducto"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
      data-backdrop="static"
      data-keyboard="false"
      href="#"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title text-center">
              Inventario por posición y producto
            </h6>
            <button
              aria-label="Close"
              class="close"
              type="button"
              @click="cerrarModal()"
            >
              <span aria-hidden="true"> ×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <label>Barra Posición</label>
                <input
                  type="text"
                  class="form-control"
                  ref="barra_posicionx"
                  v-model="currentDetalle.barra_posicion"
                />
              </div>
              <div class="col-12">
                <ProductoSelectComponentV2 :current="currentDetalle" />
              </div>
              <div class="col-6" v-if="data && data.sku">
                <h6 class="text-center">
                  Producto: <span class="text-success">{{ data.sku }}</span>
                </h6>
              </div>
              <div class="col-6" v-if="data && data.sku">
                <h6 class="text-center">
                  existencia:
                  <span class="text-success">{{ data.cantidad }}</span>
                </h6>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              @click="verInventarioDeEstacion()"
              class="btn btn-success btn-block btn-md"
            >
              Buscar <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";

export default {
  components: { ProductoSelectComponentV2 },
  props: {},
  data() {
    return {
      data: {},
      currentDetalle: {
        producto: "",
        barra_posicion: "",
      },
    };
  },
  mounted() {
    let self = this;
    $(".modal").on("shown.bs.modal", function () {
      // $(this).find('[autofocus]').focus();
      self.$refs.barra_posicionx.focus();
    });
  },
  methods: {
    cerrarModal() {
      let self = this;
      self.data = "";
      $("#modalInventarioXposicionXproducto").modal("hide");
    },
    verInventarioDeEstacion() {
      let self = this;
      DynamicService.getActionList(
        "wms",
        "picking-despacho",
        "inventario_posicion_producto",
        {
          barra_posicion: self.currentDetalle.barra_posicion,
          producto: self.currentDetalle.producto.sku,
        }
      )
        .then((response) => {
          self.data = response.data[0];
          console.log(self.data);
          self.currentDetalle.barra_posicion = "";
          self.currentDetalle.producto = "";
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Inventario de estación",
            errors.response.data.detail
          );
        });
    },
  },
};
</script>
